import { Link } from "react-router-dom";
import heroAsset from "@/assets/oli-hero-hand.png.asset.json";

const heroImage = heroAsset.url;

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <img
        src={heroImage}
        alt="Oli kitchen strainer tool"
        width={1536}
        height={1024}
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="eager"
        decoding="async"
        // @ts-expect-error: fetchpriority is a valid HTML attribute, types lag behind
        fetchpriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-background/20" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full py-20">
        <div className="max-w-2xl space-y-6 md:space-y-8">
          <h1 className="text-5xl md:text-6xl lg:text-7xl text-foreground leading-[1.05] text-balance">
            The strainer, reconsidered
          </h1>
          <p className="text-base md:text-lg text-foreground/80 max-w-lg leading-relaxed">
            A small tool for the daily ritual of clearing up. Lift, drop, done.
          </p>
          <div className="space-y-3 pt-2">
            <Link
              to="/shop"
              className="inline-block bg-primary text-primary-foreground text-base font-medium px-8 py-3.5 rounded-full hover:opacity-90 transition-opacity"
            >
              Reserve yours
            </Link>
            <p className="text-sm text-foreground/70">
              Made in Bratislava · Lifetime guarantee · Plastic-free shipping
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
